// The predefined prompts mcp/analytics-public serves. Clicking one sends a marker, not
// a question: the text is server-owned and English, so only the label is translated.
export const SUGGESTED_PROMPTS = [
  'return-rate',
  'product-performance',
  'return-reasons',
  'compensation-methods',
  'refund-methods'
] as const

export type SuggestedPromptName = (typeof SUGGESTED_PROMPTS)[number]

const MARKER_PREFIX = 'prompt:'

// The marker carries the language the label was read in, since the text it expands to is
// English. Per-marker, so it stays true for this turn if the merchant later switches.
export function promptMarker(
  name: SuggestedPromptName,
  locale: string
): string {
  const tag = /^[a-z]{2}$/.test(locale) ? `:${locale}` : ''
  return `${MARKER_PREFIX}${name}${tag}`
}

export function promptNameFromMarker(
  content: string
): SuggestedPromptName | undefined {
  if (!content.startsWith(MARKER_PREFIX)) return undefined
  const [name] = content.slice(MARKER_PREFIX.length).split(':')
  return SUGGESTED_PROMPTS.find((known) => known === name)
}
